module.exports = __webpack_public_path__ + "img/carrousel-video-12.eee58747.png";